import clsx from 'clsx'
import { type ReactNode, type ComponentPropsWithoutRef, type FC } from 'react'

import { type PageEntity } from '@/libs/api'

import { CountSummary } from '../CountSummary'
import { Overlay } from '../Overlay'
import { Pagination } from '../Pagination'

type Props = ComponentPropsWithoutRef<'div'> & {
  /** 左側に表示するアクション */
  actions?: ReactNode
  /** ページネーション情報 */
  pageEntity: PageEntity | null
  /**
   * 合計数を表示するかどうか
   * @default false
   */
  showTotal?: boolean
  /**
   * ページサイズ選択を表示するかどうか
   * @default false
   */
  showPageSizeChanger?: boolean
  /** 選択中のものがある場合に表示されるオーバーレイのアクション */
  overlayActions?: ReactNode
  /** 選択中の件数 */
  selectedLength?: number
  /** オーバーレイに追加表示する要素（選択行の集計など） */
  extra?: ReactNode
  /** ページ数 または ページサイズが変更された時のコールバック */
  onChangePage: ComponentPropsWithoutRef<typeof Pagination>['onChange']
}

/**
 * Table用のアクションバー
 */
export const TableActions: FC<Props> = ({
  className,
  actions,
  pageEntity,
  overlayActions,
  selectedLength,
  extra,
  showPageSizeChanger = false,
  showTotal = false,
  onChangePage,
  ...props
}) => {
  const visibleOverlay = overlayActions && !!selectedLength

  return (
    <div
      {...props}
      className={clsx([
        'relative flex min-h-10 items-center justify-end',
        className
      ])}
    >
      <div className="flex-1">{actions}</div>
      <div className="flex items-center gap-3">
        {showTotal && <CountSummary count={pageEntity?.total ?? null} />}
        <Pagination
          entity={pageEntity}
          showSizeChanger={showPageSizeChanger}
          onChange={onChangePage}
        />
      </div>
      <Overlay
        actions={overlayActions}
        selectedLength={selectedLength ?? 0}
        extra={extra}
        className={clsx([
          visibleOverlay ? '' : 'pointer-events-none opacity-0',
          'transition-opacity'
        ])}
      />
    </div>
  )
}
